import React, { useMemo } from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    ResponsiveContainer,
    Tooltip,
} from 'recharts';
import { buildAdsClickAnalytics } from '../utils/adsClickAnalytics';

const AdsClicksSparkline = ({ adsClicks, days = 30 }) => {
    const data = useMemo(
        () => buildAdsClickAnalytics(adsClicks, days),
        [adsClicks, days]
    );

    const { series, totalClicks = 0 } = data;

    return (
        <div className="w-[200px] min-w-[200px]">
            <ResponsiveContainer width="100%" height={56}>
                <LineChart data={series} margin={{ top: 4, right: 4, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" vertical={false} />
                    <XAxis dataKey="date" hide />
                    <YAxis hide domain={[0, 'auto']} />
                    <Tooltip
                        labelFormatter={(label) => label}
                        formatter={(value) => [value, 'Clicks']}
                        contentStyle={{ fontSize: '12px' }}
                    />
                    <Line
                        type="monotone"
                        dataKey="clicks"
                        stroke="#2563eb"
                        strokeWidth={2}
                        dot={{ r: 2, fill: '#2563eb' }}
                        activeDot={{ r: 3 }}
                        isAnimationActive={false}
                    />
                </LineChart>
            </ResponsiveContainer>
            <p className="text-[11px] text-gray-600 text-center leading-tight mt-0.5">
                {totalClicks} click{totalClicks === 1 ? '' : 's'} (30d)
            </p>
        </div>
    );
};

export default AdsClicksSparkline;
